<template>
  <Component :is="continuous ? 'div' : BaseCard" :class="containerClasses" id="candidateBasicInfo">
    <p class="w-32 bg-gradient-to-r bg-clip-text font-bold text-transparent from-bdPurple-600 to-bdOrange-600">Basic
      Info.</p>

    <div class="mt-8 flex flex-wrap gap-6">
      <CandidateBasicInfo :candidate="candidate" :small="small" :editable="editable"
                          @update:candidate="updateCandidate"/>
    </div>
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import CandidateBasicInfo from "./CandidateBasicInfo.vue";
import {computed} from "vue";

const emits = defineEmits(["update:candidate"]);
const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  small: Boolean,
  editable: Boolean,
});

const updateCandidate = (candidate) => emits("update:candidate", candidate);

const containerClasses = computed(() => {
  const baseClasses = props.continuous ? "px-4 md:px-6 mt-6" : "relative shadow-sm mt-6";
  return baseClasses + (props.small ? " text-sm" : "");
});
</script>
